import {
    LocationWidget,
    GeofenceWidget,
    SchoolModeWidget,
    RemindersWidget,
    DeviceLockWidget,
    FindDeviceWidget,
    RemoteRebootWidget,
    RemoteShutdownWidget,
    DigitalWalletWidget,
    FamilySharingWidget,
    EmergencyContactsWidget,
    SmartNotificationsWidget,
    MoodCheckinWidget,
    RewardsTasksWidget,
} from "../widgets";

export const featuresData = [
    {
        id: "location",
        titleKey: "tabs.location.title",
        descKey: "tabs.location.description",
        iconKey: "MapPin",
        color: "from-sky-400 to-blue-500",
        Widget: LocationWidget,
        scenarios: [
            { iconKey: "Baby", titleKey: "tabs.location.scenarios.0.title", descKey: "tabs.location.scenarios.0.description" },
            { iconKey: "User", titleKey: "tabs.location.scenarios.1.title", descKey: "tabs.location.scenarios.1.description" },
            { iconKey: "Briefcase", titleKey: "tabs.location.scenarios.2.title", descKey: "tabs.location.scenarios.2.description" },
            { iconKey: "Heart", titleKey: "tabs.location.scenarios.3.title", descKey: "tabs.location.scenarios.3.description" },
        ],
    },
    {
        id: "geofence",
        titleKey: "tabs.geofence.title",
        descKey: "tabs.geofence.description",
        iconKey: "AlertTriangle",
        color: "from-red-400 to-pink-500",
        Widget: GeofenceWidget,
        scenarios: [
            { iconKey: "GraduationCap", titleKey: "tabs.geofence.scenarios.0.title", descKey: "tabs.geofence.scenarios.0.description" },
            { iconKey: "Home", titleKey: "tabs.geofence.scenarios.1.title", descKey: "tabs.geofence.scenarios.1.description" },
            { iconKey: "Building", titleKey: "tabs.geofence.scenarios.2.title", descKey: "tabs.geofence.scenarios.2.description" },
            { iconKey: "Sunset", titleKey: "tabs.geofence.scenarios.3.title", descKey: "tabs.geofence.scenarios.3.description" },
        ],
    },
    {
        id: "familySharing",
        titleKey: "tabs.familySharing.title",
        descKey: "tabs.familySharing.description",
        iconKey: "Users",
        color: "from-indigo-400 to-blue-600",
        Widget: FamilySharingWidget,
        scenarios: [
            { iconKey: "Users", titleKey: "tabs.familySharing.scenarios.0.title", descKey: "tabs.familySharing.scenarios.0.description" },
            { iconKey: "User", titleKey: "tabs.familySharing.scenarios.1.title", descKey: "tabs.familySharing.scenarios.1.description" },
            { iconKey: "TrendingUp", titleKey: "tabs.familySharing.scenarios.2.title", descKey: "tabs.familySharing.scenarios.2.description" },
            { iconKey: "Shield", titleKey: "tabs.familySharing.scenarios.3.title", descKey: "tabs.familySharing.scenarios.3.description" },
        ],
    },
    {
        id: "emergencyContacts",
        titleKey: "tabs.emergencyContacts.title",
        descKey: "tabs.emergencyContacts.description",
        iconKey: "Phone",
        color: "from-rose-400 to-red-600",
        Widget: EmergencyContactsWidget,
        scenarios: [
            { iconKey: "Phone", titleKey: "tabs.emergencyContacts.scenarios.0.title", descKey: "tabs.emergencyContacts.scenarios.0.description" },
            { iconKey: "AlertTriangle", titleKey: "tabs.emergencyContacts.scenarios.1.title", descKey: "tabs.emergencyContacts.scenarios.1.description" },
            { iconKey: "AlertTriangle", titleKey: "tabs.emergencyContacts.scenarios.2.title", descKey: "tabs.emergencyContacts.scenarios.2.description" },
            { iconKey: "Heart", titleKey: "tabs.emergencyContacts.scenarios.3.title", descKey: "tabs.emergencyContacts.scenarios.3.description" },
        ],
    },
    {
        id: "schoolMode",
        titleKey: "tabs.schoolMode.title",
        descKey: "tabs.schoolMode.description",
        iconKey: "BookOpen",
        color: "from-amber-400 to-yellow-500",
        Widget: SchoolModeWidget,
        scenarios: [
            { iconKey: "PhoneOff", titleKey: "tabs.schoolMode.scenarios.0.title", descKey: "tabs.schoolMode.scenarios.0.description" },
            { iconKey: "User", titleKey: "tabs.schoolMode.scenarios.1.title", descKey: "tabs.schoolMode.scenarios.1.description" },
            { iconKey: "TrendingUp", titleKey: "tabs.schoolMode.scenarios.2.title", descKey: "tabs.schoolMode.scenarios.2.description" },
            { iconKey: "Theater", titleKey: "tabs.schoolMode.scenarios.3.title", descKey: "tabs.schoolMode.scenarios.3.description" },
        ],
    },
    {
        id: "reminders",
        titleKey: "tabs.reminders.title",
        descKey: "tabs.reminders.description",
        iconKey: "Clock",
        color: "from-green-400 to-lime-500",
        Widget: RemindersWidget,
        scenarios: [
            { iconKey: "Smile", titleKey: "tabs.reminders.scenarios.0.title", descKey: "tabs.reminders.scenarios.0.description" },
            { iconKey: "Pill", titleKey: "tabs.reminders.scenarios.1.title", descKey: "tabs.reminders.scenarios.1.description" },
            { iconKey: "Briefcase", titleKey: "tabs.reminders.scenarios.2.title", descKey: "tabs.reminders.scenarios.2.description" },
            { iconKey: "Flower2", titleKey: "tabs.reminders.scenarios.3.title", descKey: "tabs.reminders.scenarios.3.description" },
        ],
    },
    {
        id: "deviceLock",
        titleKey: "tabs.deviceLock.title",
        descKey: "tabs.deviceLock.description",
        iconKey: "Lock",
        color: "from-slate-400 to-gray-500",
        Widget: DeviceLockWidget,
        scenarios: [
            { iconKey: "PhoneOff", titleKey: "tabs.deviceLock.scenarios.0.title", descKey: "tabs.deviceLock.scenarios.0.description" },
            { iconKey: "Smile", titleKey: "tabs.deviceLock.scenarios.1.title", descKey: "tabs.deviceLock.scenarios.1.description" },
            { iconKey: "Ban", titleKey: "tabs.deviceLock.scenarios.2.title", descKey: "tabs.deviceLock.scenarios.2.description" },
            { iconKey: "Utensils", titleKey: "tabs.deviceLock.scenarios.3.title", descKey: "tabs.deviceLock.scenarios.3.description" },
        ],
    },
    {
        id: "remoteReboot",
        titleKey: "tabs.remoteReboot.title",
        descKey: "tabs.remoteReboot.description",
        iconKey: "RotateCcw",
        color: "from-cyan-400 to-teal-500",
        Widget: RemoteRebootWidget,
        scenarios: [
            { iconKey: "GraduationCap", titleKey: "tabs.remoteReboot.scenarios.0.title", descKey: "tabs.remoteReboot.scenarios.0.description" },
            { iconKey: "UserX", titleKey: "tabs.remoteReboot.scenarios.1.title", descKey: "tabs.remoteReboot.scenarios.1.description" },
            { iconKey: "Laptop", titleKey: "tabs.remoteReboot.scenarios.2.title", descKey: "tabs.remoteReboot.scenarios.2.description" },
            { iconKey: "Puzzle", titleKey: "tabs.remoteReboot.scenarios.3.title", descKey: "tabs.remoteReboot.scenarios.3.description" },
        ],
    },
    {
        id: "remoteShutdown",
        titleKey: "tabs.remoteShutdown.title",
        descKey: "tabs.remoteShutdown.description",
        iconKey: "Power",
        color: "from-neutral-400 to-stone-500",
        Widget: RemoteShutdownWidget,
        scenarios: [
            { iconKey: "Moon", titleKey: "tabs.remoteShutdown.scenarios.0.title", descKey: "tabs.remoteShutdown.scenarios.0.description" },
            { iconKey: "Bed", titleKey: "tabs.remoteShutdown.scenarios.1.title", descKey: "tabs.remoteShutdown.scenarios.1.description" },
            { iconKey: "VolumeX", titleKey: "tabs.remoteShutdown.scenarios.2.title", descKey: "tabs.remoteShutdown.scenarios.2.description" },
            { iconKey: "Theater", titleKey: "tabs.remoteShutdown.scenarios.3.title", descKey: "tabs.remoteShutdown.scenarios.3.description" },
        ],
    },
    {
        id: "findDevice",
        titleKey: "tabs_continued.findDevice.title",
        descKey: "tabs_continued.findDevice.description",
        iconKey: "Search",
        color: "from-violet-400 to-purple-500",
        Widget: FindDeviceWidget,
        scenarios: [
            { iconKey: "LocateFixed", titleKey: "tabs_continued.findDevice.scenarios.0.title", descKey: "tabs_continued.findDevice.scenarios.0.description" },
            { iconKey: "Sofa", titleKey: "tabs_continued.findDevice.scenarios.1.title", descKey: "tabs_continued.findDevice.scenarios.1.description" },
            { iconKey: "Factory", titleKey: "tabs_continued.findDevice.scenarios.2.title", descKey: "tabs_continued.findDevice.scenarios.2.description" },
            { iconKey: "MapPin", titleKey: "tabs_continued.findDevice.scenarios.3.title", descKey: "tabs_continued.findDevice.scenarios.3.description" },
        ],
    },
    {
        id: "digitalWallet",
        titleKey: "tabs_continued.digitalWallet.title",
        descKey: "tabs_continued.digitalWallet.description",
        iconKey: "CreditCard",
        color: "from-emerald-400 to-green-500",
        Widget: DigitalWalletWidget,
        scenarios: [
            { iconKey: "Coffee", titleKey: "tabs_continued.digitalWallet.scenarios.0.title", descKey: "tabs_continued.digitalWallet.scenarios.0.description" },
            { iconKey: "UserX", titleKey: "tabs_continued.digitalWallet.scenarios.1.title", descKey: "tabs_continued.digitalWallet.scenarios.1.description" },
            { iconKey: "Building", titleKey: "tabs_continued.digitalWallet.scenarios.2.title", descKey: "tabs_continued.digitalWallet.scenarios.2.description" },
            { iconKey: "Gift", titleKey: "tabs_continued.digitalWallet.scenarios.3.title", descKey: "tabs_continued.digitalWallet.scenarios.3.description" },
        ],
    },
    {
        id: "smartNotifications",
        titleKey: "tabs_continued.smartNotifications.title",
        descKey: "tabs_continued.smartNotifications.description",
        iconKey: "Bell",
        color: "from-fuchsia-400 to-purple-600",
        Widget: SmartNotificationsWidget,
        scenarios: [
            { iconKey: "Gamepad2", titleKey: "tabs_continued.smartNotifications.scenarios.0.title", descKey: "tabs_continued.smartNotifications.scenarios.0.description" },
            { iconKey: "Heart", titleKey: "tabs_continued.smartNotifications.scenarios.1.title", descKey: "tabs_continued.smartNotifications.scenarios.1.description" },
            { iconKey: "Calendar", titleKey: "tabs_continued.smartNotifications.scenarios.2.title", descKey: "tabs_continued.smartNotifications.scenarios.2.description" },
            { iconKey: "Heart", titleKey: "tabs_continued.smartNotifications.scenarios.3.title", descKey: "tabs_continued.smartNotifications.scenarios.3.description" },
        ],
    },
    {
        id: "moodCheckin",
        titleKey: "tabs_continued.moodCheckin.title",
        descKey: "tabs_continued.moodCheckin.description",
        iconKey: "Heart",
        color: "from-pink-400 to-rose-500",
        Widget: MoodCheckinWidget,
        scenarios: [
            { iconKey: "Smile", titleKey: "tabs_continued.moodCheckin.scenarios.0.title", descKey: "tabs_continued.moodCheckin.scenarios.0.description" },
            { iconKey: "User", titleKey: "tabs_continued.moodCheckin.scenarios.1.title", descKey: "tabs_continued.moodCheckin.scenarios.1.description" },
            { iconKey: "Briefcase", titleKey: "tabs_continued.moodCheckin.scenarios.2.title", descKey: "tabs_continued.moodCheckin.scenarios.2.description" },
            { iconKey: "Heart", titleKey: "tabs_continued.moodCheckin.scenarios.3.title", descKey: "tabs_continued.moodCheckin.scenarios.3.description" },
        ],
    },
    {
        id: "rewardsTasks",
        titleKey: "tabs_continued.rewardsTasks.title",
        descKey: "tabs_continued.rewardsTasks.description",
        iconKey: "Trophy",
        color: "from-amber-400 to-orange-500",
        Widget: RewardsTasksWidget,
        scenarios: [
            { iconKey: "Star", titleKey: "tabs_continued.rewardsTasks.scenarios.0.title", descKey: "tabs_continued.rewardsTasks.scenarios.0.description" },
            { iconKey: "Check", titleKey: "tabs_continued.rewardsTasks.scenarios.1.title", descKey: "tabs_continued.rewardsTasks.scenarios.1.description" },
            { iconKey: "TrendingUp", titleKey: "tabs_continued.rewardsTasks.scenarios.2.title", descKey: "tabs_continued.rewardsTasks.scenarios.2.description" },
            { iconKey: "Gift", titleKey: "tabs_continued.rewardsTasks.scenarios.3.title", descKey: "tabs_continued.rewardsTasks.scenarios.3.description" },
        ],
    },
];
